import { style } from '@vanilla-extract/css';

export const publicDrawerContentInnerContainer = style({
  maxWidth: '450px',
  margin: '0 auto',
});
